document.querySelectorAll('.map__checkboxes-item').forEach(button => { 
	button.addEventListener("click", function(e) {
		e.preventDefault();
		var url = new URL(window.location.href);
		var params = new URLSearchParams(url.search);

        if (params.has('search')) {
            params.delete('search');
        }

		if (params.has('categories') && params.get('categories').split(',').find(category => category === button.dataset.category)) {
			params.set('categories', params.get('categories').split(',').filter(category => category !== button.dataset.category).join(','));
		} else if (params.has('categories') && params.get('categories')) {
			params.set('categories', params.get('categories') + ',' + button.dataset.category);
		} else {
			params.set('categories', button.dataset.category);
		}
		window.location.search = params.toString();
	})
})
document.querySelectorAll('.map__bottom-button').forEach(function(button) {
	button.addEventListener('click', function() {
		button.parentNode.classList.add('active')
	})
})

document.querySelectorAll('.map__bottom-dropdown-close').forEach(function(button) {
	button.addEventListener('click', function() {
		button.parentNode.parentNode.classList.remove('active')
	})
})

document.querySelectorAll('.map__checkboxes').forEach(function(picker) {
	picker.querySelector('.map__checkboxes-button span').addEventListener('click', function() {
		if (!picker.classList.contains('blured')) {
			this.parentNode.parentNode.classList.toggle('active')
			this.parentNode.parentNode.focus()
		}
	})
	picker.addEventListener('blur', function() {
		this.classList.remove('active')
		this.classList.add('blured')
		setTimeout(() => {
			this.classList.remove('blured')
		}, 200)
	})
})

const $map_locator = function () {
    "use strict";
    
    let dom_section = `section[id^="map-locator-block"]`,
        dom_description = `${dom_section} div.description`;
    
    function onTriggerMouseEnter() {
        jQuery( document ).off( "mouseenter", dom_description ).on( "mouseenter", dom_description, function ( e ) {
            e.preventDefault();
            
            let trigger = jQuery( this ).find( "div.trigger" ),
                r = trigger.get( 0 ).getBoundingClientRect(),
                wrap = jQuery( this ).find( ".description-wrap" ),
                group_x = r.x + ( r.width / 2 ) - ( wrap.outerWidth() / 2 ),
                group_y = r.y - wrap.outerHeight();
            
            wrap.css({
                top: group_y,
                left: group_x,
                position: "fixed",
                zIndex: 10
            });
        });
        
        jQuery( document ).off( "mouseleave", dom_description ).on( "mouseleave", dom_description, function ( e ) {
            e.preventDefault();
            
            let wrap = jQuery( this ).find( ".description-wrap" );
            
            setTimeout( function () {
                wrap.removeAttr( "style" );
            }, 50 );
        });
    }
    
    function onWindowScroll() {
        jQuery( window ).on( "scroll", function ( e ) {
            let wrap = jQuery( dom_description ).find( ".description-wrap" );
            
            wrap.css({
                opacity: 0,
                visibility: "hidden"
            });
            
            setTimeout( function () {
                wrap.removeAttr( "style" );
            }, 50 );
        });
    }
    
    $map_locator.run = function () {
        onTriggerMouseEnter();
        onWindowScroll();
    };
    
    return $map_locator;
};

jQuery( document ).ready( function () {
    $map_locator().run();
});
